/**
 * WordPress dependencies
 */
import domReady from '@wordpress/dom-ready';

/**
 * Internal dependencies
 */
import { SchedulePDFGenerator } from './assets/SchedulePDFGenerator';

/**
 * On DOM ready
 */
domReady(() => {
	// Select all buttons by class
	const buttons = document.querySelectorAll('.download-time-schedule');

	if (buttons.length === 0) {
		return;
	}

	// Create PDF generator instance with custom config (optional)
	const pdfGenerator = new SchedulePDFGenerator({
		// You can override any default settings here
	});

	// Add click event listener to each button
	buttons.forEach((button) => {
		button.addEventListener('click', (event) => {
			// Prevent default behavior if any
			event.preventDefault();

			// Get the current tabpanel where the button is located
			// The button is assumed to be inside a [role="tabpanel"]
			const panel = button.closest('[role="tabpanel"]');

			if (!panel) {
				console.warn(
					'Schedule PDF Generator: Could not find parent tabpanel for button.',
					button
				);
				return;
			}

			// Convert to PDF using the specific panel content
			pdfGenerator.convert(panel);
		});
	});
});
